/**
 * Ryan O'Dowd
 * 2023-12-29
 * © Copyright 2023 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React, {
  useEffect,
  useState,
} from 'react';
import {
  TouchableOpacity,
  View,
} from 'react-native';
import Badge from '@components/common/Badge';
import getStyles from './styles';
import hooks from '@hooks';

const ListItem = (_p: ListItemProps) => {
  const props = {
    ...defaultProps,
    ..._p,
  };

  const styles = hooks.useStyles(getStyles);
  const [_isExpanded, setIsExpanded] = useState(!!props.accordionContent && props.isExpanded);

  useEffect(() => {
    setIsExpanded(!!props.isExpanded);
  }, [props.isExpanded]);

  return (
    <View
      style={[styles.listItemContainer, props.containerStyles, styles.noexist]}
      onLayout={props.onLayout}
    >
      <TouchableOpacity
        disabled={props.disabled || !props.onPress}
        style={[styles.listItemInner, props.variant === 'accent' && styles.accentListItemInner, _isExpanded && styles.listItemInnerOpenAccordion, props.innerStyles]}
        onPress={() => {
          props.onPress?.();
          setIsExpanded((curr) => !!props.accordionContent && !curr);
        }}
      >
        {props.children}
      </TouchableOpacity>
      {_isExpanded && props.accordionContent &&
        <View style={[styles.accordionContent, props.variant === 'accent' && styles.accentAccordionContent]}>
          {props.accordionContent}
        </View>
      }
      <Badge visible={props.hasBadge} size={props.badgeTextSize}>
        {props.badgeText}
      </Badge>
    </View>
  );
};

class ListItemProps {
  variant?: 'primary' | 'accent' = 'primary';
  children?: React.ReactNode;
  containerStyles?: any;
  innerStyles?: any;
  accordionContent?: React.ReactNode;
  onPress?: () => void;
  isExpanded?: boolean;
  hasBadge?: boolean;
  badgeText?: string;
  badgeTextSize?: number;
  disabled?: boolean;
  onLayout?: (e: any) => void;
};
const defaultProps = new ListItemProps();

export default ListItem;
